import financialGuideDoc from 'static/documents/FM__ASIC__FSG_August_2024.pdf';
import pdsDoc from 'static/documents/FM_PDS_September_2023-ASIC.pdf';
import termsDoc from 'static/documents/FM_ASIC_Terms_Conditions_January_2025.pdf';
import reduceFeesTermsDoc from 'static/documents/Refer a Friend - T&Cs.pdf';
import privacyDoc from 'static/documents/FM_Privacy_Policy_September_2023-ASIC.pdf';
import TMDDoc from 'static/documents/FM_ASIC_TMD_September_2023.pdf';
import TradingViewPromotionDoc from 'static/documents/FM__ASIC__TradingView_Promotion_May_2024.pdf';

import termsXDoc from 'static/documents/Financial_Product_Terms_-_VFSC.pdf';
import clientServicesAgreementFsaDoc from 'static/documents/regulators/sey/Client_Services_Agreement_FSA.pdf';
import complaintHandlingPolicyFsaDoc from 'static/documents/regulators/sey/Complaint_Handling_Policy_FSA.pdf';
import privacyPolicyFsaDoc from 'static/documents/regulators/sey/Privacy_Policy_FSA.pdf';
import conflictInterestFsaDoc from 'static/documents/regulators/sey/Conflicts_of_Interest_Policy_FSA.pdf';
import refundAndReturnFsaDoc from 'static/documents/regulators/sey/Refund_and_Return_Policy_FSA.pdf';
import rafFsaDoc from 'static/documents/regulators/sey/Fusion_Markets_RAF_FSA.docx';
import tvFsaDoc from 'static/documents/regulators/sey/TV_Promo_FM_December_2024_FSA.docx';
import pdsXDoc from 'static/documents/Product Disclosure Statement - VFSC.pdf';
import privacyXDoc from 'static/documents/Privacy_Policy - VFSC.pdf';
import TradingViewPromotionXDoc from 'static/documents/FM__VSFC__TradingView_Promotion_December_2024.pdf';

import cryptoDay1TermsDoc from 'static/documents/Terms_and_Conditions_Crypto.pdf';

import riskDisclosureDoc from 'static/documents/FM_EU_Risk_Disclosure_and_Warnings_Notice_March_2025.pdf';
import conflictsDoc from 'static/documents/FM_EU_Conflicts_of_Interest_March_2025.pdf';
import privacyEUDoc from 'static/documents/FM_EU_Privacy_Policy_March_2025.pdf';
import orderExecutionDoc from 'static/documents/FM_EU_Order_Execution_Policy_March_2025.pdf';
import categorizationDoc from 'static/documents/FM_EU_Client_Categorisation_Policy_March_2025.pdf';
import agreementDoc from 'static/documents/FM_EU_Client_Agreement_March_2025.pdf';
import companyInfoDoc from 'static/documents/FM_EU_Company_Information_March_2025.pdf';
import complaintsDoc from 'static/documents/FM_EU_Complaints_Procedure_For_Clients_March_2025.pdf';
import investorCompensationFundDoc from 'static/documents/FM_EU_Investor_Compensation_Fund_March_2025.pdf';
import costsAndAssociatedChargesDoc from 'static/documents/FM_EU_Costs_and_Associated_Charges_March_2025.pdf';
import cookiesPolicy from 'static/documents/FM_EU_Cookie Policy_March_2025.pdf';

import { REGULATOR } from './regulators';
import { getMarketingUrlByRoutingHub } from 'helpers/hubs';

export const getDocumentsAu = () => ({
  pds: pdsDoc,
  terms: termsDoc,
  reduceFeesTerms: reduceFeesTermsDoc,
  financialGuide: financialGuideDoc,
  privacy: privacyDoc,
  tmd: TMDDoc,
  tradingViewPromotion: TradingViewPromotionDoc,
  cryptoDay1Terms: cryptoDay1TermsDoc,
});

export const getDocumentsEn = () => ({
  pds: pdsXDoc,
  terms: termsXDoc,
  privacy: privacyXDoc,
  reduceFeesTerms: reduceFeesTermsDoc,
  financialGuide: financialGuideDoc,
  tradingViewPromotion: TradingViewPromotionXDoc,
  cryptoDay1Terms: cryptoDay1TermsDoc,
});

export const getDocumentsSey = () => ({
  pds: pdsXDoc,
  terms: clientServicesAgreementFsaDoc,
  complaintHandlingPolicy: complaintHandlingPolicyFsaDoc,
  conflicts: conflictInterestFsaDoc,
  refundAndReturn: refundAndReturnFsaDoc,
  privacy: privacyPolicyFsaDoc,
  reduceFeesTerms: rafFsaDoc,
  financialGuide: financialGuideDoc,
  tradingViewPromotion: tvFsaDoc,
  cryptoDay1Terms: cryptoDay1TermsDoc,
});

export const getDocumentsEu = ({ routingHub }) => ({
  riskDisclosure: riskDisclosureDoc,
  conflicts: conflictsDoc,
  orderExecution: orderExecutionDoc,
  categorization: categorizationDoc,
  agreement: agreementDoc,
  companyInfo: companyInfoDoc,
  complaints: complaintsDoc,
  investorCompensationFund: investorCompensationFundDoc,
  privacy: privacyEUDoc,
  costs: costsAndAssociatedChargesDoc,
  cookiesPolicy: cookiesPolicy,
  keyInfoDocs: getMarketingUrlByRoutingHub(routingHub, 'REGULATIONS_URL'),
});

export const REGULATOR_TO_DOCS = {
  [REGULATOR.ASIC]: getDocumentsAu,
  [REGULATOR.VFSC]: getDocumentsEn,
  [REGULATOR.SEY]: getDocumentsSey,
  [REGULATOR.CYSEC]: getDocumentsEu,
};
